
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/legal-stuff",
      function () {
        return require("private-next-pages/fr/legal-stuff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/legal-stuff"])
      });
    }
  